import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import r from '@/kit/RoundButton/button.module.scss';
import IconCheck from './icon_check.svg';
import s from './index.module.scss';

export const DoneStep = ({ newEmail, closeModal }) => {
  const { t } = useTranslation('modal');

  return (
    <div className={classnames(s.modal, s.modal_small)}>
      <div className={s.content}>
        <div className={s.done}>
          <div className={s.success}>
            <img src={IconCheck} alt="Done" />
            <div className={s.success_text}>
              <div className="f-20-32 f-500">
                {t('change_email_modal.email_changed')}
              </div>
              <div>
                <Trans
                  ns="modal"
                  i18nKey="change_email_modal.email_changed_successfully"
                  values={{ newEmail }}
                  components={{
                    span: <span className="f-500" />,
                  }}
                />
              </div>
            </div>
          </div>
          <div className={s.footer}>
            <button
              type="button"
              className={classnames(s.button, r.black_large)}
              style={{ width: '100%' }}
              onClick={closeModal}
            >
              {t('change_email_modal.got_it')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}